import React from "react";
import { useCart } from "../contexts/CartContext";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { Button } from "../components/ui/button";
import { Trash2, Plus, Minus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../contexts/LangContext";

export default function CartDrawer() {
  const { items, remove, setQty, subtotal, open, setOpen, count } = useCart();
  const { t } = useLang();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" side="right" className="w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle className="editorial-heading text-2xl">Carrello ({count})</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto mt-4 space-y-3">
          {items.length === 0 && (
            <div data-testid="cart-empty" className="text-center py-12 text-muted-foreground">{t("cart.empty", "Il tuo carrello è vuoto")}</div>
          )}
          {items.map((it) => (
            <div key={`${it.product_id}-${it.unit}`} data-testid={`cart-item-${it.product_id}`} className="flex gap-3 border-b border-border pb-3">
              {it.image && <img src={it.image} alt={it.name} className="w-16 h-16 object-cover rounded-sm" />}
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm truncate">{it.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">€{it.unit_price.toFixed(2)} / {it.unit}</div>
                <div className="flex items-center gap-2 mt-2">
                  <button data-testid={`cart-dec-${it.product_id}`} onClick={() => setQty(it.product_id, it.unit, it.quantity - 1)} className="p-1 hover:bg-muted rounded"><Minus className="h-3 w-3" /></button>
                  <span className="text-sm font-medium w-8 text-center">{it.quantity}</span>
                  <button data-testid={`cart-inc-${it.product_id}`} onClick={() => setQty(it.product_id, it.unit, it.quantity + 1)} className="p-1 hover:bg-muted rounded"><Plus className="h-3 w-3" /></button>
                </div>
              </div>
              <button data-testid={`cart-remove-${it.product_id}`} onClick={() => remove(it.product_id, it.unit)} className="text-muted-foreground hover:text-destructive self-start p-1">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-border pt-4 space-y-3">
            <div className="flex justify-between text-sm"><span>{t("cart.subtotal", "Subtotale")}</span><span className="font-semibold">€{subtotal.toFixed(2)}</span></div>
            <Button
              data-testid="cart-checkout-btn"
              className="w-full bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm"
              size="lg"
              onClick={() => { setOpen(false); nav("/checkout"); }}
            >
              {t("cart.checkout", "Vai al checkout")}
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
